import React from 'react'
import AutoglyphLogo from '../images/glyphstats_logo.png';
import FilterImage from '../images/filter.svg';
// imports
import SearchIcon from "@material-ui/icons/Search";
import { Link } from "react-router-dom";

const Header = ({ setSearchAutoglyph, callSearchApi, search, display_searchbar, toggleFilters, toggleAbout, buttons, glyphClose }) => {

    const [isSearchActive, setSearchActive] = React.useState(false);

    const toggleSearch = () => {
		setSearchActive(!isSearchActive);
	}
    return (
        <div>
            <div className="glyph_state">
                <div className="glyph_state_filter">
                    <div className="glyph_state_left">
                        <Link
                            className="logo"
                            style={{textDecoration: 'none'}}
                            to={{
                                pathname: `/`,
                            }}
                        >
                            <img src={AutoglyphLogo} alt="autoglyph logo" className="autoglyph_logo left" width="640" height="179" />
                        </Link>
                    </div>
                    {
                        search ?
                        <div className={`glyph_state_right ${isSearchActive ? 'active' : 'inactive'}`}>
                            {
                                    display_searchbar &&

                                    <form onSubmit={(e) => callSearchApi(e)}>
                                        <input type="text" placeholder="Search Autoglyph#" onChange={(e) => setSearchAutoglyph(e.target.value)} />
                                        <button type="submit"> <SearchIcon /></button>
                                    </form>
                                }
                                
                            </div>
                            : ''

                    }

                    <div className="header_nav">

                        <div onClick={toggleAbout} className="header_about">About</div>

                        { glyphClose ? 
                            <div onClick={toggleAbout} className="header_glyph_close">
                                <Link to="/">Close</Link>
                            </div>
                            : ''
                        }

                    </div>
                     
                     { buttons ?
                     <div className="mobile_header_buttons">
                         <div className="toggle_search" onClick={toggleSearch}>
                             <SearchIcon />
                         </div>
                         <div className="toggle_filter" onClick={toggleFilters}>
                             <img src={FilterImage} alt="Toggle Filters" width="26" />
                         </div>
                     </div>
                        : ''
                     }
                </div>
            </div>
        </div>
    )
}

export default Header




// WEBPACK FOOTER //
// ./src/components/Header.js